export enum TransferPeriod {
  SUMMER = 'summer',
  WINTER = 'winter',
}

export function getUiString(period: TransferPeriod): string | null {
  switch (period) {
    case TransferPeriod.SUMMER:
      return 'Sommer';
    case TransferPeriod.WINTER:
      return 'Winter';
    default:
      return null;
  }
}
